import { Environment, EnvironmentVariables } from '@app-types/environment.types'

export const environment: EnvironmentVariables = {
    production: true,
    name: Environment.Production,
    title: 'De Eekhoorn',
    isCrawlAble: true,
    url: 'deeekhoorn.com',
    api: {
        clientId: '965838ed-e9a1-431f-8f86-05f03246bf26',
        schema: 'https',
        hostname: 'api.deeekhoorn.com',
        backoffice: 'backoffice.deeekhoorn.com',
        oauthCallbackUrl: '/authentication/callback',
        oauthLoginUrl: '/authorize',
        oauthTokenUrl: '/oauth/token',
        // Unused yet, but will be used in the future!
        acceptVersionRange: '>=0.0.1 <1.0.0',
    },
    subscriptionGraphql: {
        schema: 'wss',
        hostname: 'deeekhoorn.com',
    },
    algolia: {
        appId: 'EAWFDZLNSQ',
        apiKey: 'c503699295db9fe0ad7f33ca81394343',
        default_index: 'deeekhoorn_en',
        hitsPerPage: 1500,
    },
    google: {
        maps: 'AIzaSyDvGcUrmDskBB_IVxU4vbOdPJVLK00JSQY',
        recaptcha: '6LcflXoiAAAAACWN4L_ICjcdaSfHlf6L7OPkC3e1',
        gtm: 'GTM-MMXKQJ',
    },
}
